import axios from 'axios';
import { ResponsiveEmbed } from 'react-bootstrap';
import { call, put, select } from 'redux-saga/effects';
import { API } from '../constants/api';
import { methods } from '../constants/constants';
import { actions } from '../reducers/users';
import { sagaNames, handleSagaError } from './index';
import { beginExplicitLogoutFlow, clearExplicitLogoutFlow } from '../utils/logoutFlow';

function makeLoginData(args) {
    return axios({
        method: methods.POST,
        url: API.LOGIN.MAKE_LOGIN,
        data: {
            user: args.userOrEmail,
            email: args.userOrEmail,
            contrasena: args.pass,
        },
    });
}

function makeLogoutData() {
	return axios({
		method: methods.POST,
		url: API.LOGIN.MAKE_LOGOUT,
	});
}

function getAuthenticatedData() {
	return axios({
		method: methods.GET,
		url: API.LOGIN.GET_AUTHENTICATED_USER,
	});
}

function changePasswordData(args) {
    return axios({
        method: methods.PUT,
        url: API.USUARIOS.CHANGE_PASSWORD,
        data: {
            contrasenaActual: args.currentPassword,
            nuevaContrasena: args.newPassword,
            confirmacionContrasena: args.confirmPassword,
        },
    });
}

export function* makeLogin(args) {
  try {
    const response = yield call(makeLoginData, args.payload);
        clearExplicitLogoutFlow();
    const data = {
      data: {
        "rol": "admin",
        "token": "eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYWRtaW4iLCJleHAiOjE3MDExMjYwMDAsImlzcyI6IjgifQ.S1RTGAfls527KyH6X4VzOSTC734QeOuX9Fmc9SpxY74",
        "menu": [
            {
                "urlKey": "home",
                "name": "Login",
                "subItem": []
            },
            {
                "urlKey": "academies",
                "name": "Academias",
                "subItem": []
            },
            {
                "urlKey": "materias",
                "name": "Materias",
                "subItem": []
            },
            {
                "urlKey": "usuarios",
                "name": "Usuarios",
                "subItem": []
            },
            {
                "urlKey": "examenes",
                "name": "Exámenes",
                "subItem": []
            },
            {
                "urlKey": "buscadorpreguntas",
                "name": "Buscador de preguntas",
                "subItem": []
            },
            {
                "urlKey": "",
                "name": "Realizar Examen",
                "subItem": [
                    {
                        "urlKey": "realizarexamenrapido",
                        "name": "Rápido",
                        "subItem": []
                    }
                ]
            }
        ]
      }
    }
    yield put(actions.successMakeLogin(response));
  } catch (error) {
    const reducerFailureAction = actions.errorMakeLogin(error);
    yield handleSagaError(sagaNames.MAKE_LOGIN, error, reducerFailureAction);
  }
}

export function* makeLogout() {
  try {
        beginExplicitLogoutFlow();
    const response = yield call(makeLogoutData);
    yield put(actions.successMakeLogout(response));
    yield put(actions.resetUser());
  } catch (error) {
        const status = error?.status || error?.response?.status;

        if (status !== 401 && status !== 498) {
            clearExplicitLogoutFlow();
        }

    const reducerFailureAction = actions.errorMakeLogout(error);
        yield handleSagaError(sagaNames.MAKE_LOGOUT, error, reducerFailureAction);
  }
}

export function* getAuthenticated() {
  try {
    const response = yield call(getAuthenticatedData);
        clearExplicitLogoutFlow();
    const data = {
      data: {
        "usuario": {
            "id": 8,
            "id_academia": 2,
            "email": "pepero@mail.com",
            "user": "pepero",
            "rol": "admin",
            "id_academia_priv": 2,
            "contrasena": "$2a$11$BEtA/eRFoduC3syLu5Fr9ulpaL6aKVAFDw/Sla88X8d.7nyyityRS"
        },
        "menu": [
            {
                "urlKey": "home",
                "name": "Login",
                "subItem": []
            },
            {
                "urlKey": "academies",
                "name": "Academias",
                "subItem": []
            },
            {
                "urlKey": "materias",
                "name": "Materias",
                "subItem": []
            },
            {
                "urlKey": "usuarios",
                "name": "Usuarios",
                "subItem": []
            },
            {
                "urlKey": "examenes",
                "name": "Exámenes",
                "subItem": []
            },
            {
                "urlKey": "buscadorpreguntas",
                "name": "Buscador de preguntas",
                "subItem": []
            },
            {
                "urlKey": "",
                "name": "Realizar Examen",
                "subItem": [
                    {
                        "urlKey": "realizarexamenrapido",
                        "name": "Rápido",
                        "subItem": []
                    }
                ]
            }
        ]
      },
      status: 200,
    }
    yield put(actions.successGetAuthenticated(response));
  } catch (error) {
    const reducerFailureAction = actions.errorGetAuthenticated(error);
    yield handleSagaError(sagaNames.GET_AUTHENTICATED, error, reducerFailureAction);
  }
}

export function* changePassword(args) {
    try {
        const response = yield call(changePasswordData, args.payload);
        yield put(actions.successChangePassword(response));
    } catch (error) {
        const reducerFailureAction = actions.errorChangePassword(error);
        yield handleSagaError(sagaNames.CHANGE_PASSWORD, error, reducerFailureAction);
    }
}
